// import AvueComponent from "../src/components/index";
// import echartComponents from "../src/echart/index";
import bem from "@/echart/bem";
import $Echart from '@/echart/common';

import DataCenter from "@/option/components/dataCenter/index.vue";
// import OptionComponents from "../src/option/components.js";
// import Avue from "@smallwei/avue";
// import "@smallwei/avue/lib/index.css";
import "@/styles/toAida.scss";
import bar from "@/echart/packages/bar/index.vue";
import bar3D from "@/echart/packages/bar3D/index.vue";
import line from "@/echart/packages/line/index.vue";
import pie from "@/echart/packages/pie/index.vue";
import scatter from "@/echart/packages/scatter/index.vue";
import rectangle from "@/echart/packages/rectangle/index.vue";
import funnel from "@/echart/packages/funnel/index.vue";
import pieCircle from "@/components/pieCircleIndex/index.vue";
import horizontalBar from "@/components/HorizontalBar/index.vue";
import mixBar from "@/components/MixBar/index.vue";
import mixBarNew from "@/components/MixBarNew/index.vue";
import radar from "@/echart/packages/radar/index.vue";
import gauge from "@/echart/packages/gauge/index.vue";
import progress from "@/echart/packages/progress/index.vue";
import indexCard from "@/components/indexCard/index.vue";
import sheet from "@/components/Sheet/index.vue";
import textAreaModel from "@/components/TextAreaModel/index.vue"


import barOption from "@/option/components/bar.vue";
import lineOption from "@/option/components/line.vue";
import pieOption from "@/option/components/pie.vue";
import scatterOption from "@/option/components/scatter.vue";
import rectangleOption from "@/option/components/rectangle.vue";
import funnelOption from "@/option/components/funnel.vue";
import maincomOption from "@/option/components/maincom.vue";
import pieCircleOption from "@/components/pieCircleIndex/option.vue";
import horizontalBarOption from "@/components/HorizontalBar/option.vue";
import mixBarOption from "@/components/MixBar/option.vue";
import mixBarNewOption from "@/components/MixBarNew/option.vue";
import radarOption from "@/option/components/radar.vue";
import gaugeOption from "@/option/components/gauge.vue";
import progressOption from "@/option/components/progress.vue";
import indexCardOption from "@/components/indexCard/option.vue";
import sheetOption from "@/components/Sheet/option.vue";
import textAreaModelOption from "@/components/TextAreaModel/option.vue";
import {deepClone, setPx, validData} from "@/acomponets/utils/util.js";
import {validatenull} from "@/acomponets/utils/validate.js";
import FilterRule from '@/option/components/dataCenter/Rule.vue'
import ThemeConfig from '@/page/components/themeConfig.vue'
import {version} from './package.json'
import PresentMode from '@/page/group/presentMode.vue'

const mixins = [bem, $Echart];
const componentsList = [
  bar,
  bar3D,
  line,
  pie,
  scatter,
  rectangle,
  funnel,
  pieCircle,
  horizontalBar,
  mixBar,
  mixBarNew,
  radar,
  gauge,
  progress,
  indexCard,
  sheet,
  textAreaModel
];
const optionsList = [
  barOption,
  lineOption,
  pieOption,
  scatterOption,
  rectangleOption,
  funnelOption,
  maincomOption,
  horizontalBarOption,
  pieCircleOption,
  mixBarOption,
  mixBarNewOption,
  radarOption,
  gaugeOption,
  progressOption,
  indexCardOption,
  sheetOption,
  textAreaModelOption
];

const components = componentsList.reduce((total, v) => {
  v.mixins = [...mixins];
  total[v.name] = v;
  return total;
}, {});

const options = optionsList.reduce((total, v) => {
  total[v.name + "Option"] = v;
  return total;
}, {});

// 全局动态添加组件
const install = (app, {axios}) => {
  localStorage.setItem("@zk-ui/big-screen", version)
  // 避免重复定义，此处统一用$_axios来表示，aida插件、大屏插件、zk-ui共用该变量
  if (axios) {
    window.$bs_request = axios
  }
  app.config.globalProperties.setPx = setPx;
  app.config.globalProperties.deepClone = deepClone;
  app.config.globalProperties.validData = validData;
  app.config.globalProperties.validatenull = validatenull;
  for (const [key, component] of Object.entries(components)) {
    app.component(key, component);
  }
  app.component('FilterRule', FilterRule);
  // app.use(Avue, {
  //   axios,
  // });
};

// const componentsList = { ...echartComponents };
// const components = configAd.reduce((total, v) => {
//   const key = `avue-echart-${v}`
//   if (Reflect.has(componentsList, key)) {
//     total[key] = componentsList[key];
//   }
//   return total;
// }, {});

export default {
  install,
  packages: {
    ...components,
    PresentMode
  }, // 组件包
  options: {...options}, // 组件属性选项
  // options: { ...OptionComponents.components }, // 组件属性选项
  config: {DataCenter, ThemeConfig}, // 配置项
};

